import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
	currentSettingsRequest: ['data'],
	currentSettingsSuccess: ['payload'],
	currentSettingsFailure: null,
	setCurrentChild: ['child'],
	setSettings: ['locale', 'settings'],
})

export const CurrentSettingsTypes = Types
export const CurrentSettingsActions = Creators
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
	data: null,
	fetching: null,
	payload: null,
	error: null,

	child: null,
	locale: null,
	settings: null,
})

/* ------------- Selectors ------------- */

export const CurrentSettingsSelectors = {
	getData: (state: any) => state.currentSettings.data,
	getCurrentChild: (state: any) => state.currentSettings.child,
	getLocale: (state: any) => state.currentSettings.locale,
	getSettings: (state: any) => state.currentSettings.settings,
	isFetching: (state: any) => state.currentSettings.fetching,
	isSuccess: (state: any) => state.currentSettings.payload !== null,
	hasError: (state: any) => state.currentSettings.error,
}

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state: any, {data}: any) => {
	const updateData = {
		fetching: true,
		data,
		payload: null
	}
	return state.merge ? state.merge(updateData) : { ...state, ...updateData }
}

// successful api lookup
export const success = (state: any, action: any) => {
	const {payload} = action
	const updateData = {
		fetching: false,
		error: null,
		payload
	}
	return state.merge ? state.merge(updateData) : { ...state, ...updateData }
}

// Something went wrong somewhere.
export const failure = (state: any) => {
	const updateData = {
		fetching: false,
		error: true,
		payload: null
	}
	return state.merge ? state.merge(updateData) : { ...state, ...updateData }
}

export const setCurrentChild = (state: any, {child}: any) => {
	const updateData = {
		child: child,
	}
	return state.merge ? state.merge(updateData) : { ...state, ...updateData }
}

export const setSettings = (state: any, {locale, settings}: any) => {
	const updateData = {
		locale,
		notifications: settings,
	}
	return state.merge ? state.merge(updateData) : { ...state, ...updateData }
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.CURRENT_SETTINGS_REQUEST]: request,
	[Types.CURRENT_SETTINGS_SUCCESS]: success,
	[Types.CURRENT_SETTINGS_FAILURE]: failure,

	[Types.SET_CURRENT_CHILD]: setCurrentChild,
	[Types.SET_SETTINGS]: setSettings,
})
